import { Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';
import { IComponentCanDeactivate } from '@check-list/app/classes/component-can-deactivate';
import { TranslocoService } from '@ngneat/transloco';
import { NzModalService } from 'ng-zorro-antd/modal';
import { Observable } from 'rxjs';

@Injectable()
export class PendingChangesGuard
  implements CanDeactivate<IComponentCanDeactivate> {
  constructor(
    private modal: NzModalService,
    private translocoService: TranslocoService
  ) {}

  canDeactivate(
    component: IComponentCanDeactivate
  ): boolean | Observable<boolean> {
    // if there are no pending changes, just allow deactivation; else confirm first
    return component.canDeactivate()
      ? true
      : // NOTE: this warning message will only be shown when navigating elsewhere within your angular app;
        // when navigating away from your angular app, the browser will show a generic warning message
        // see http://stackoverflow.com/a/42207299/7307355
        // confirm('WARNING: You have unsaved changes. Press Cancel to go back and save these changes, or OK to lose these changes.');
        this.modal.confirm({
          nzTitle: this.translocoService.translate(
            'dialogs.confirm.exit.title'
          ),
          nzContent: this.translocoService.translate(
            'dialogs.confirm.exit.content'
          ),
          nzOnOk: () => new Promise((resolve) => resolve(true))
        }).afterClose;
  }
}
